import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux'
import styles from './ImportingModeModal.css'
import {hideImportingModeModal} from 'actions/customers/list'

class ImportingModeModal extends React.Component {
  render () {
    let {showImportingModeModal} = this.props
    return (<Modal onHide={this._onHide} show={showImportingModeModal} dialogClassName={`${styles.dialog} modal-dialog`}>
      <Modal.Header>
        <Modal.Title className={styles['title-modal']}>Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          Your customer is in importing mode, you can&#39;t access customers until importing has finished
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button type='button' className='btn btn-primary' onClick={this._onHide}>
            OK
          </button>
        </div>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    this.props.dispatch(hideImportingModeModal())
  }
}

function mapStateToProps (state) {
  const {showImportingModeModal} = state.customers.list
  return {
    showImportingModeModal
  }
}
export default connect(mapStateToProps)(ImportingModeModal)



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/ImportingModeModal/ImportingModeModal.js